export enum AppInformationNeedEnumeration {
  AUTHORIZATION_DATA = 'AUTHORIZATION_DATA',
  CHECKOUT_DATA = 'CHECKOUT_DATA',
  TRANSLATIONS = 'TRANSLATIONS',
}
